function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q8man"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M383.6,146.1c0-16.7-3.7-61.7-5.8-82.2c-2.1-21.9-4.2-46.5-27.2-46.5c-23,0-25.6,25.7-27.5,47.9 c-1.8,20.3-5.5,66.7-5.5,80.8C317.6,166.2,383.6,166.2,383.6,146.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M318.5,149.9c0,0-1.4,9.5,6.8,13.2c13.8,6.3,14.9-2.7,14.9-2.7"
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 325.3,
  y1: 192,
  x2: 328.5,
  y2: 164.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M330.5,198.1l-16.5-0.2c0,0,6.9-6.4,13-5.4S330.5,198.1,330.5,198.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M382.6,150.1c0,0,2.2,9.2-6,13c-13.8,6.3-14.9-2.7-14.9-2.7"
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 376.6,
  y1: 192,
  x2: 373.4,
  y2: 164.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M371.3,197.8l16.5,0.5c0,0-6.7-6.7-12.9-6C368.9,193.1,371.3,197.8,371.3,197.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 344.4,
  cy: 50.5,
  r: 1.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 356.8,
  cy: 50.5,
  r: 1.7
})), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M334.9,61.1c1.9,4.2,7.4-1.4,15.8-1.4h-0.1c8.4,0,13.9,5.7,15.8,1.4"
})), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M386.1,97.1L386.1,97.1c1.5-0.7,3.1,0.1,3.7,1.9l12.7,37c0.6,1.8-0.1,3.8-1.6,4.5l0,0 c-1.5,0.7-3.1-0.1-3.7-1.9l-12.7-37C383.9,99.9,384.6,97.8,386.1,97.1z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M315.8,99.6L315.8,99.6c-1.5-0.7-3.1,0.1-3.7,1.9l-12.7,37c-0.6,1.8,0.1,3.8,1.6,4.5h0 c1.5,0.7,3.1-0.1,3.7-1.9l12.7-37C317.9,102.4,317.2,100.3,315.8,99.6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q8rolling2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Q8clothL2",
  className: "st4",
  d: "M320.9,74.9c0,0-28.4,10.3-30.4,27.6c-0.9,8,28,15.9,28,15.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q8clothR2",
  className: "st4",
  d: "M381.2,74.9c0,0,25.3,11.3,27.3,28.6c0.9,8-24.9,14.9-24.9,14.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q8cloth2",
  className: "st4",
  d: "M395.9,126.6c0-25.4-16.5-62.9-16.5-62.9h-57.3c0,0-16.6,37.3-16.6,62.4 c10.1,3.9,42.1,21.2,45.2,21.2C353.5,147.2,384.3,131,395.9,126.6z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Q8rolling"
}, /*#__PURE__*/React.createElement("path", {
  id: "Q8r1",
  className: "st1",
  d: "M454.9,38.6c35.9,0.9,32.2,44,7.9,46.6c-16.5,1.7-26.9-7.7-27.8-21.4c-0.9-13.1,5.3-24.2,18.5-25.1 c10.5-0.7,19.6,7.2,20.3,17.7c0.6,8.4-5.8,15.7-14.2,16.3c-6.7,0.5-12.5-4.6-13-11.3c-0.4-5.4,3.7-10,9.1-10.4c4.3-0.3,8,3,8.3,7.3 c0.2,3.4-2.4,6.4-5.8,6.7c-2.8,0.2-5.1-1.9-5.3-4.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q8r2",
  className: "st1",
  d: "M247.5,87.2c35.9,0.9,32.2,44,7.9,46.6c-16.5,1.7-26.9-7.7-27.8-21.4c-0.9-13.1,5.3-24.2,18.5-25.1 c10.5-0.7,19.6,7.2,20.3,17.7c0.6,8.4-5.8,15.7-14.2,16.3c-6.7,0.5-12.5-4.6-13-11.3c-0.4-5.4,3.7-10,9.1-10.4c4.3-0.3,8,3,8.3,7.3 c0.2,3.4-2.4,6.4-5.8,6.7c-2.8,0.2-5.1-1.9-5.3-4.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q8r3",
  className: "st3",
  d: "M423.9,165.4c22.8,0.6,20.4,27.9,5,29.5c-10.4,1.1-17-4.9-17.6-13.6c-0.6-8.3,3.4-15.4,11.7-15.9 c6.7-0.5,12.4,4.6,12.9,11.2c0.4,5.3-3.7,9.9-9,10.3c-4.3,0.3-8-2.9-8.2-7.2c-0.2-3.4,2.3-6.4,5.8-6.6c2.7-0.2,5.1,1.9,5.3,4.6 c0.1,2.2-1.5,4.1-3.7,4.2c-1.7,0.1-3.3-1.2-3.4-2.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Q8clothL",
  className: "st4",
  d: "M320.9,74.9c0,0-15.8,15.5-17.8,32.8c-0.9,8,15.4,10.8,15.4,10.8"
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q8clothLdown",
  attributeName: "d",
  attributeType: "XML",
  dur: "0.55s",
  begin: "none",
  fill: "freeze",
  from: "M320.9,74.9c0,0-28.4,10.3-30.4,27.6c-0.9,8,28,15.9,28,15.9",
  to: "M320.9,74.9c0,0-15.8,15.5-17.8,32.8c-0.9,8,15.4,10.8,15.4,10.8"
})), /*#__PURE__*/React.createElement("path", {
  id: "Q8clothR",
  className: "st4",
  d: "M381.2,74.9c0,0,15.8,15.5,17.8,32.8c0.9,8-15.4,10.8-15.4,10.8"
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q8clothRdown",
  attributeName: "d",
  attributeType: "XML",
  dur: "0.55s",
  begin: "none",
  fill: "freeze",
  from: "M381.2,74.9c0,0,25.3,11.3,27.3,28.6c0.9,8-24.9,14.9-24.9,14.9",
  to: "M381.2,74.9c0,0,15.8,15.5,17.8,32.8c0.9,8-15.4,10.8-15.4,10.8"
})), /*#__PURE__*/React.createElement("path", {
  id: "Q8cloth",
  className: "st4",
  d: "M383.7,126.6c0-25.4-4.3-62.9-4.3-62.9h-57.3c0,0-4.4,37.3-4.4,62.4c7.3,3.9,30,21.2,33,21.2 C353.5,147.2,375.2,131,383.7,126.6z"
}, /*#__PURE__*/React.createElement("animate", {
  className: "Q8clothdown",
  attributeName: "d",
  attributeType: "XML",
  dur: "0.55s",
  begin: "none",
  fill: "freeze",
  from: "M395.9,126.6c0-25.4-16.5-62.9-16.5-62.9h-57.3c0,0-16.6,37.3-16.6,62.4c10.1,3.9,42.1,21.2,45.2,21.2C353.5,147.2,384.3,131,395.9,126.6z",
  to: "M383.7,126.6c0-25.4-4.3-62.9-4.3-62.9h-57.3c0,0-4.4,37.3-4.4,62.4c7.3,3.9,30,21.2,33,21.2C353.5,147.2,375.2,131,383.7,126.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Q8head"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M374.1,57.2c-13.6,4-33.2,4-46.7,0c-1.2,4.6-1.7,9.3-1.7,13.8c0,0.7,0,1.4,0,2.4c0,0.6,0.1,1.2,0.3,1.8 c13.8,5.1,35.8,5.1,49.6,0c0.2-0.6,0.3-1.2,0.3-1.8c0-0.9,0-1.7,0-2.4C375.8,66.5,375.2,61.8,374.1,57.2z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M350.7,9.4c-25.4,0-36.4,27.6-36.4,51.9c0,1,0,2.1,0,3.5c0,4.9,3.6,8.7,9.2,11.5c1.5,0.7,3-0.6,3.1-2.5 c0-0.3,0-0.5,0-0.5c0-16.3,7.1-37.2,24.1-37.2c17,0,23.5,18,24,34.6l0.1,3.9c0,1.6,1.3,2.6,2.6,2c5.9-2.7,9.7-6.7,9.7-11.7 c0-1.4,0-2.5,0-3.5C387.1,37,376.1,9.4,350.7,9.4z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Q8defense"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M336.6,136.2c4.2,0.4,8.9,0.6,14.1,0.6c5.4,0,10.3-0.2,14.7-0.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M333.2,146.5l-17.4,4l-1.7,9.1c0,0,13.5,4.8,36.7,4.8s37.6-3.9,37.6-3.9l-2.3-9.7l-17.8-4.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M320.8,75.3c0,0-15.8,15.5-17.8,32.8c-0.9,8,15.4,10.8,15.4,10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M381.1,75.3c0,0,15.8,15.5,17.8,32.8c0.9,8-15.4,10.8-15.4,10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M322.7,74.6c0,0,14.2,5.9,27.9,5.9c13.7,0,27.7-5.9,27.7-5.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M322.7,79.8c0,0,14.2,15.4,27.9,15.4c13.7,0,27.7-15.4,27.7-15.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st8",
  points: "336.1,119.5 350.6,110.6 365.1,119.5  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 350.6,
  y1: 110.6,
  x2: 350.6,
  y2: 95.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 343.8,
  y1: 114.7,
  x2: 342.4,
  y2: 93.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 336.7,
  y1: 119.2,
  x2: 334.8,
  y2: 89.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 328.7,
  y1: 115.8,
  x2: 327.1,
  y2: 83.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 357.3,
  y1: 114.7,
  x2: 358.8,
  y2: 93.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 364.5,
  y1: 119.2,
  x2: 366.4,
  y2: 89.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 372.5,
  y1: 115.8,
  x2: 374.1,
  y2: 83.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st9",
  cx: 350.7,
  cy: 127,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  className: "st9",
  cx: 350.7,
  cy: 127,
  r: 4
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "381.1,112.1 358.8,116.5 358.8,124.1 381.1,124.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "387.4,150.9 368.2,146.5 362.6,129.7 382.8,129.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "314.1,150.9 333.2,146.5 338.8,129.7 318.7,129.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "318.4,112.1 342.6,116.5 342.6,124.1 318.4,124.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "385,130 316.4,130 317,124.1 384.2,124.1  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 323.2,
  y1: 161.9,
  x2: 326.1,
  y2: 148.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 334.5,
  y1: 163.6,
  x2: 341.9,
  y2: 130
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 378.7,
  y1: 161.9,
  x2: 375.8,
  y2: 148.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 367.5,
  y1: 163.6,
  x2: 360.1,
  y2: 130
}), /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: 351,
  y1: 156,
  x2: 351,
  y2: 164.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M315.8,150.5c4.3,1.3,16.6,4.3,34.9,4.3c17.9,0,30.5-2.3,35.4-3.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M334.1,145.2c4.8,0.5,10.4,0.9,16.7,0.9c6.3,0,11.9-0.3,16.7-0.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st6",
  points: "345.1,130 343.1,156 358.8,156 356.3,130  "
}), /*#__PURE__*/React.createElement("circle", {
  className: "st10",
  cx: 350.7,
  cy: 127,
  r: 6.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st9",
  cx: 350.7,
  cy: 127,
  r: 2.2
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M381.2,103.2c-0.6-8.4-1.3-16.7-2-24.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M322.3,74.5c-0.9,10.8-2,24.6-2.9,37.6"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M381.2,75.9c0-0.4-0.1-0.9-0.1-1.3l1.4-0.8l-1.8-3.2l-1.5,0.8c-0.6-0.6-1.4-1-2.2-1.3v-1.7h-3.6v1.7 c-0.8,0.3-1.6,0.7-2.2,1.3l-1.5-0.8l-1.8,3.2l1.4,0.8c-0.1,0.4-0.1,0.8-0.1,1.3c0,0.4,0.1,0.9,0.1,1.3l-1.4,0.8l1.8,3.2l1.5-0.8 c0.6,0.6,1.4,1,2.2,1.3v1.7h3.6v-1.7c0.8-0.3,1.6-0.7,2.2-1.3l1.5,0.8l1.8-3.2l-1.4-0.8C381.2,76.8,381.2,76.4,381.2,75.9z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 375.2,
  cy: 75.9,
  r: 2.4
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M332.3,75.9c0-0.4-0.1-0.9-0.1-1.3l1.4-0.8l-1.8-3.2l-1.5,0.8c-0.6-0.6-1.4-1-2.2-1.3v-1.7h-3.6v1.7 c-0.8,0.3-1.6,0.7-2.2,1.3l-1.5-0.8l-1.8,3.2l1.4,0.8c-0.1,0.4-0.1,0.8-0.1,1.3c0,0.4,0.1,0.9,0.1,1.3L319,78l1.8,3.2l1.5-0.8 c0.6,0.6,1.4,1,2.2,1.3v1.7h3.6v-1.7c0.8-0.3,1.6-0.7,2.2-1.3l1.5,0.8l1.8-3.2l-1.4-0.8C332.3,76.8,332.3,76.4,332.3,75.9z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 326.3,
  cy: 75.9,
  r: 2.4
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q8shield"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "st13",
  cx: 399,
  cy: 133.8,
  rx: 35.3,
  ry: 35.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M398.9,155.7c12.1,0,21.9-9.8,21.9-21.9c0-3.2-4.2-2.6-5.2-3.9c-1.1-1.5-1.1-3-1.1-4.5 c0-1.1-0.2-3.4-0.2-3.4l-31.1-0.4c0,0,0.1,2.2,0.1,3.7c0,1.4,0,3-1.1,4.5c-1,1.3-5.2,0.7-5.2,3.9c0,12.1,9.8,21.9,21.9,21.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M414.5,125c-0.7,0.7-1.7,2-2.4,3.6c-2.2,4.7-0.7,10.1-0.7,10.1l-12.5,16.3l-12.5-16.3c0,0,1.4-5.4-0.7-10.1 c-0.8-1.8-1.5-2.9-2.3-3.6l-0.2-2.8h31.4L414.5,125z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st14",
  x1: 389.4,
  y1: 136.2,
  x2: 386.3,
  y2: 138.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st14",
  x1: 408.1,
  y1: 136.2,
  x2: 411.1,
  y2: 138.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st14",
  x1: 398.8,
  y1: 145.6,
  x2: 398.8,
  y2: 154.9
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M416,102.8l-0.4,0c0,0-5.5,4.6-16.8,4.6c-11.2,0-16.8-4.6-16.8-4.6c-4.1,2.3-7.7,5.3-10.7,9 c0.6,2.9,2.2,9.8,4.2,10.7c2.6,1.1,10.8-1.1,12.7,3.4c1.9,4.5,1.1,10.5,1.1,10.5l9.3,9.4l9.3-9.4c0,0-0.7-6,1.1-10.5 c1.9-4.5,10.1-2.2,12.7-3.4c2.1-0.9,3.8-8.4,4.3-11C423.4,107.9,419.9,105,416,102.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M413.1,101.3c-2.6,1.3-7.4,3.1-14.3,3.1c-6.8,0-11.5-1.7-14.2-3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M402.8,125.6l-2.7,2.8c-0.7,0.7-1.8,0.7-2.5,0l-2.7-2.8c-0.3-0.3-0.5-0.8-0.5-1.3v-11.1c0-1,0.8-1.8,1.8-1.8 h5.5c1,0,1.8,0.8,1.8,1.8v11.1C403.3,124.8,403.1,125.3,402.8,125.6z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 393.2,
  cy: 162.8,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 383.1,
  cy: 157.9,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 375.6,
  cy: 150.8,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 378.4,
  cy: 127,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 418.4,
  cy: 127,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 404.4,
  cy: 162.8,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 414.5,
  cy: 157.9,
  r: 1.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "st16",
  cx: 422,
  cy: 150.8,
  r: 1.9
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q8crown"
}, /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M352.6,15.2c-1.2,2.6,0.5,7.3,5.3,11.6c4.5,4,9.8,4.9,13.8,1.6c2.6-2.2,9.9-9.2,9.9-9.2l-8.1-1l2.3-8.2 l-11.6-0.6l-0.7-8.7C363.5,0.6,354.9,10.2,352.6,15.2z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 91.7231 263.209)",
  className: "st17",
  cx: 363.6,
  cy: 20.9,
  rx: 3.8,
  ry: 2.5
})));

var SvgQ8Svg = function SvgQ8Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q8svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ8Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q8svg.0fb320e2.svg";
export { ForwardRef as ReactComponent };